var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoconnectmgi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 675.147,
    height: 192,
    viewBox: "0 0 675.147 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M2.593,99.017a92.09,92.09,0,1,1,1.873,18.574A92.09,92.09,0,0,1,2.593,99.017Z",
    transform: "translate(-2.593 -7.02)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logoconnectmgi",
    transform: "translate(-1145.803 -188.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    transform: "translate(1146.95 -46.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_577",
    transform: "translate(233 236.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_474",
    transform: "translate(2.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1192",
    d: "M179.945-23.9H163.416l-.386,1.081-1.467,7.183-.386,1.081-.7,3.939v1.081l-.7,2.163L159.4-5.9h11.817a9.211,9.211,0,0,0,7.878-6.488h0l1.081-4.325v-.7l1.081-5.02.386-1.467Z",
    transform: "translate(-3.694 23.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1193",
    d: "M160.6,3.5h-4.634L140.9,74.943h5.02a13.414,13.414,0,0,0,12.59-10.427L171.408,3.5Z",
    transform: "translate(0.518 17.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1194",
    d: "M7.308,62.824l18.3-39.081L14.877,74.718H29.629L42.141,15.865a11.463,11.463,0,0,0-1.467-9.732,10.2,10.2,0,0,0-8.96-3.553,16.412,16.412,0,0,0-4.325.386,14.257,14.257,0,0,0-10.736,8.959L-2.038,50.312l-.309-38.386A8.716,8.716,0,0,0-9.529,2.889a16.953,16.953,0,0,0-3.939-.309A17.516,17.516,0,0,0-23.9,6.133a17.514,17.514,0,0,0-5.715,9.732L-42.2,74.718h14.752l10.736-50.975,1.467,38.077.386,5.02c0,1.081.386,2.549.386,3.553.7,3.553,3.939,6.488,7.569,6.1A10.852,10.852,0,0,0,2.75,71.087l.386-.386a34.39,34.39,0,0,0,2.549-3.939Z",
    transform: "translate(42.2 17.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1195",
    d: "M66.494,63a10.926,10.926,0,0,0,.386,3.553,7.5,7.5,0,0,0,3.939,5.715,19.4,19.4,0,0,0,10.736,2.549h17.61a17.857,17.857,0,0,0,16.142-8.65,23.87,23.87,0,0,0,3.244-9.654l4.634-22.63H105.961l-1.776,7.878h1.776L103.1,55.735v.386c-.7,2.163-2.549,3.244-5.715,3.244h-12.2c-1.467-.386-2.549-1.467-2.549-2.549V56.43L90.205,21.6a3.874,3.874,0,0,1,3.553-2.858H122.1L125.344,3.3H96.307A23.161,23.161,0,0,0,81.941,7.386a24.789,24.789,0,0,0-6.8,13.671S67.267,58.748,66.88,60.215A8.354,8.354,0,0,0,66.494,63Z",
    transform: "translate(17.461 17.715)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1451",
    d: "M-45,36.5",
    transform: "translate(45 10.15)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    width: 460.95,
    height: 125.7,
    transform: "translate(1360 255)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "dashboardlogocompletw",
    transform: "translate(1027.95 -261.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DASHBOARD",
    d: "M37.62-6.66A23.9,23.9,0,0,0,49.59-9.765,25.012,25.012,0,0,0,58.41-18l6.93,4.5a31.755,31.755,0,0,1-5.13,6.21,32.264,32.264,0,0,1-6.57,4.77A33.974,33.974,0,0,1,45.99.54a32.344,32.344,0,0,1-8.37,1.08A32.049,32.049,0,0,1,24.75-.99,33.619,33.619,0,0,1,14.22-8.1,33.619,33.619,0,0,1,7.11-18.63,32.049,32.049,0,0,1,4.5-31.5,32.049,32.049,0,0,1,7.11-44.37,33.619,33.619,0,0,1,14.22-54.9a33.619,33.619,0,0,1,10.53-7.11,32.049,32.049,0,0,1,12.87-2.61,32.151,32.151,0,0,1,16.02,4.1A32.779,32.779,0,0,1,65.34-49.59L58.41-45a25.012,25.012,0,0,0-8.82-8.235,23.9,23.9,0,0,0-11.97-3.1,23.8,23.8,0,0,0-9.585,1.935,25.115,25.115,0,0,0-7.83,5.31,24.835,24.835,0,0,0-5.31,7.92A24.44,24.44,0,0,0,12.96-31.5,24.44,24.44,0,0,0,14.9-21.825a24.835,24.835,0,0,0,5.31,7.92,25.115,25.115,0,0,0,7.83,5.31A23.8,23.8,0,0,0,37.62-6.66Zm69.84-57.96a32.049,32.049,0,0,1,12.87,2.61,33.62,33.62,0,0,1,10.53,7.11,33.62,33.62,0,0,1,7.11,10.53,32.049,32.049,0,0,1,2.61,12.87,32.049,32.049,0,0,1-2.61,12.87A33.62,33.62,0,0,1,130.86-8.1,33.62,33.62,0,0,1,120.33-.99a32.049,32.049,0,0,1-12.87,2.61A32.272,32.272,0,0,1,94.5-.99,33.079,33.079,0,0,1,84.015-8.1,34.011,34.011,0,0,1,76.95-18.63,32.049,32.049,0,0,1,74.34-31.5a32.049,32.049,0,0,1,2.61-12.87A34.011,34.011,0,0,1,84.015-54.9,33.079,33.079,0,0,1,94.5-62.01,32.272,32.272,0,0,1,107.46-64.62Zm0,57.96A23.8,23.8,0,0,0,117.045-8.6a24.576,24.576,0,0,0,7.785-5.31,25.216,25.216,0,0,0,5.265-7.92A24.44,24.44,0,0,0,132.03-31.5a24.117,24.117,0,0,0-1.935-9.63,25.358,25.358,0,0,0-5.265-7.875,25.2,25.2,0,0,0-7.785-5.355,23.331,23.331,0,0,0-9.585-1.98,23.644,23.644,0,0,0-9.63,1.98A25.056,25.056,0,0,0,90-49.005a25.358,25.358,0,0,0-5.265,7.875A24.117,24.117,0,0,0,82.8-31.5a24.44,24.44,0,0,0,1.935,9.675A25.216,25.216,0,0,0,90-13.905,24.44,24.44,0,0,0,97.83-8.6,24.117,24.117,0,0,0,107.46-6.66ZM192.96-63h8.55V0h-8.37l-31.5-47.79V0h-8.46V-63h8.37l31.41,47.7Zm64.53,0h8.55V0h-8.37l-31.5-47.79V0h-8.46V-63h8.37l31.41,47.7Zm67.68,8.28H291.69v19.08h31.05v8.28H291.69V-8.28h33.48V0H283.14V-63h42.03ZM367.29-6.66a23.9,23.9,0,0,0,11.97-3.105A25.012,25.012,0,0,0,388.08-18l6.93,4.5a31.755,31.755,0,0,1-5.13,6.21,32.265,32.265,0,0,1-6.57,4.77A33.974,33.974,0,0,1,375.66.54a32.344,32.344,0,0,1-8.37,1.08A32.049,32.049,0,0,1,354.42-.99,33.62,33.62,0,0,1,343.89-8.1a33.62,33.62,0,0,1-7.11-10.53,32.049,32.049,0,0,1-2.61-12.87,32.049,32.049,0,0,1,2.61-12.87,33.62,33.62,0,0,1,7.11-10.53,33.62,33.62,0,0,1,10.53-7.11,32.049,32.049,0,0,1,12.87-2.61,32.151,32.151,0,0,1,16.02,4.1,32.779,32.779,0,0,1,11.7,10.935L388.08-45a25.012,25.012,0,0,0-8.82-8.235,23.9,23.9,0,0,0-11.97-3.1,23.8,23.8,0,0,0-9.585,1.935,25.115,25.115,0,0,0-7.83,5.31,24.835,24.835,0,0,0-5.31,7.92A24.44,24.44,0,0,0,342.63-31.5a24.44,24.44,0,0,0,1.935,9.675,24.835,24.835,0,0,0,5.31,7.92,25.115,25.115,0,0,0,7.83,5.31A23.8,23.8,0,0,0,367.29-6.66ZM446.31-63v8.01H427.59V0h-8.46V-54.99H400.41V-63Z",
    transform: "translate(346 630.451)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo-BG-Approve",
    transform: "translate(1143.21 183.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6",
    "data-name": "Groupe 6",
    transform: "translate(2.593 6.912)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 92.194,
    cy: 92.194,
    r: 92.194,
    transform: "translate(0 0)",
    fill: "#004b93"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0 0.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5",
    "data-name": "Groupe 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 200.791,
    height: 129.806,
    transform: "translate(-11.699 -31.375)",
    fill: "#0094cd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    "data-name": "Groupe 4",
    transform: "translate(36.627 22.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M75.514,12.616A55.726,55.726,0,0,1,103.264,25.5c-2.373,2.162-4.67,4.407-6.89,6.676a46.372,46.372,0,1,0,15.872,26.605,81.314,81.314,0,0,1,8.6-5.157A55.991,55.991,0,1,1,75.509,12.616",
    transform: "translate(-10.713 -11.917)",
    fill: "#004b93",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M16.057,51.751A55.8,55.8,0,0,1,38.363,42.2c5.251,8.279,9.559,19.494,10.353,26.943C66.622,46,88.979,17.314,110.063,13.082A94.264,94.264,0,0,0,103.915,43.5C81.277,50.145,59.692,75.963,44.8,93.193,39.544,79.235,29.952,58.6,16.057,51.751",
    transform: "translate(8.06 -7.817)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "AP",
    transform: "translate(38.813 157.162)",
    fill: "#fff",
    fontSize: 70,
    fontFamily: "Young",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.05em"
  }, "P")))), /*#__PURE__*/React.createElement("g", {
    id: "b-2",
    "data-name": "b",
    transform: "translate(1146.477 189.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_11",
    "data-name": "Groupe 11",
    transform: "translate(-0.477 -0.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_10",
    "data-name": "Groupe 10"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 93,
    cy: 93,
    r: 93,
    fill: "#004b93"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c-2",
    "data-name": "c",
    transform: "translate(28.103 17.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ligne_1",
    "data-name": "Ligne 1",
    d: "M3.352,59.477H-.235V0H3.352Z",
    transform: "translate(62.598 78.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M47.16,42.487H21.26a6.581,6.581,0,0,1-6.573-6.573V12.443H18.27V35.914A2.99,2.99,0,0,0,21.257,38.9h25.9Z",
    transform: "translate(69.997 65.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M30.973,42.487H5.07V38.9h25.9a2.99,2.99,0,0,0,2.986-2.986V12.443h3.587V35.914a6.581,6.581,0,0,1-6.57,6.573Z",
    transform: "translate(6.088 65.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    "data-name": "Trac\\xE9 14",
    d: "M106.818,80.344A25.108,25.108,0,1,0,98,31.749,34.823,34.823,0,0,0,28.78,35.9a21.875,21.875,0,0,0-2.853-.2,22.316,22.316,0,1,0,0,44.633h80.891Z",
    transform: "translate(-3.611 -2.229)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 13.047,
    cy: 13.047,
    r: 13.047,
    transform: "translate(26.214 110.852)",
    fill: "#fbba00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 13.047,
    cy: 13.047,
    r: 13.047,
    transform: "translate(79.213 142.078)",
    fill: "#98c226"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 13.047,
    cy: 13.047,
    r: 13.047,
    transform: "translate(134.438 110.852)",
    fill: "#0094cd"
  })), /*#__PURE__*/React.createElement("text", {
    id: "C-3",
    "data-name": "C",
    transform: "translate(66.492 83.084)",
    fill: "#004b93",
    fontSize: 69,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C")), /*#__PURE__*/React.createElement("path", {
    id: "C_-_Contour",
    "data-name": "C - Contour",
    d: "M23.774,44.457c-7.051,0-12.783-2.29-17.035-6.807S.345,27.159.345,19.866C.345,12.031,2.762,5.6,7.528.761a24.583,24.583,0,0,1,18.215-7.3,29.447,29.447,0,0,1,11.7,2.033l.329.144V2.949l-.819-.454A22.971,22.971,0,0,0,25.675-.332,17.323,17.323,0,0,0,12.484,5.05C9.124,8.633,7.421,13.5,7.421,19.529c0,5.713,1.59,10.319,4.725,13.689a16.179,16.179,0,0,0,12.375,5.061A23.69,23.69,0,0,0,36.93,35.126l.837-.5v6.79l-.293.154a29.412,29.412,0,0,1-13.7,2.887ZM25.743-5.451A23.515,23.515,0,0,0,8.316,1.524c-4.559,4.632-6.87,10.8-6.87,18.342,0,7.008,2.052,12.74,6.1,17.037s9.5,6.461,16.23,6.461a28.67,28.67,0,0,0,12.891-2.615V36.538a25.2,25.2,0,0,1-12.145,2.834A17.242,17.242,0,0,1,11.337,33.96C8.008,30.381,6.32,25.526,6.32,19.53c0-6.31,1.8-11.432,5.358-15.223a18.388,18.388,0,0,1,14-5.731,24.188,24.188,0,0,1,10.99,2.533V-3.65a28.919,28.919,0,0,0-10.925-1.8Z",
    transform: "translate(68.787 40.064)",
    fill: "#004b93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoconnectmgi);
export default __webpack_public_path__ + "static/media/logoconnectmgi.66112ecd4d31953887d2de23f3cf1683.svg";
export { ForwardRef as ReactComponent };